import {
  EVENT_NAME,
  EVENT_TYPE,
  EventAttributes,
} from '@cash-rewards/mparticlejs';
import {
  getAuthToken,
  isAuthTokenExpired,
  useMparticle,
} from '@cash-rewards/reactjs';

export interface StoreTrackingAttributes {
  merchantId: number;
  hyphenatedString: string;
  clientCommissionString: string;
  name: string;
}

export const useFavouriteStoreTracking = () => {
  const { trackEvent } = useMparticle();

  const trackFavourite = async (
    value: boolean,
    store: StoreTrackingAttributes,
    customAttributes?: EventAttributes
  ) => {
    const token = await getAuthToken();
    const isSignedIn = !!(token && !isAuthTokenExpired());
    const mergedAttributes: EventAttributes = {
      signed_in: isSignedIn,
      merchant_name: store.name,
      merchant_hyphenated_string: store.hyphenatedString,
      merchant_base_cashback_rate: store.clientCommissionString,
      merchant_id: store.merchantId,
      ...customAttributes,
    };
    const event: EVENT_NAME = value
      ? EVENT_NAME.click_merchant_add_to_favourites
      : EVENT_NAME.click_merchant_remove_from_favourites;
    trackEvent(event, EVENT_TYPE.UserPreference, mergedAttributes);
  };

  return { trackFavourite };
};
